/**
 * Shared domain types used across multiple feature modules.
 * These are types that naturally belong to more than one feature boundary.
 */
import type { Result } from './result'
import type { ApiError } from './errors'

// ── Convenience alias ───────────────────────────────────────────

/** Shorthand for API operation results. Avoids repeating Result<T, ApiError> everywhere. */
export type ApiResult<T> = Result<T, ApiError>

// ── Resource types ──────────────────────────────────────────────

/** Resource type enum — shared between generation, resources, and search. */
export const RESOURCE_TYPE = {
  CHECKPOINT: 'checkpoint',
  LORA: 'lora',
  VAE: 'vae',
  CONTROLNET: 'controlnet',
  UPSCALER: 'upscaler',
  EMBEDDING: 'embedding',
} as const

export type ResourceType = (typeof RESOURCE_TYPE)[keyof typeof RESOURCE_TYPE]

// ── LoRA reference ──────────────────────────────────────────────

/** LoRA reference with weight — shared between generation and history. */
export interface LoraWeight {
  readonly resource_id: string
  readonly weight: number
}
